import { render } from "./LearningSetupSummaryBackgrounds.vue?vue&type=template&id=521bb095&scoped=true"
const script = {}

import "./LearningSetupSummaryBackgrounds.vue?vue&type=style&index=0&id=521bb095&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-521bb095"]])

export default __exports__